import { ConditionRenderer } from "@/components/shared/condition-renderer";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { cn } from "@/lib/utils";
import { Minus, Plus } from "lucide-react";
import React, { useState } from "react";

type DocumentCollapsibleProp = {
  children: React.ReactNode;
  label: string;
  preLabel?: string;
  modifiedBy?: string;
  isParent?: boolean;
};

export const AuditCollapsible = ({
  children,
  label,
  isParent,
  preLabel,
  modifiedBy,
}: DocumentCollapsibleProp) => {
  const [open, setOpen] = useState(true);
  return (
    <Collapsible
      open={open}
      onOpenChange={setOpen}
      className={cn(
        isParent ? "" : "bg-white border",
        "  rounded-xl overflow-hidden"
      )}
    >
      <CollapsibleTrigger
        className={cn(
          "flex py-2 justify-start gap-3 items-center w-full text-left px-3 font-medium",
          "text-sm",
          open ? "border-transparent border-b-slate-200 border-2 " : "",
          isParent ? "bg-white !border-2 rounded-xl border-[#0000001a]" : ""
        )}
      >
        <span className="border rounded-sm p-1">
          <ConditionRenderer condition={open}>
            <Minus strokeWidth={1} size={15} />
            <Plus strokeWidth={1} size={15} />
          </ConditionRenderer>
        </span>
        {preLabel ? <span className="text-slate-500 ">{preLabel}</span> : null}
        {label}
        {modifiedBy ? (
          <span>
            <span className="text-slate-500">Updated By:</span> {modifiedBy}
          </span>
        ) : null}
      </CollapsibleTrigger>
      <CollapsibleContent className={cn("", isParent ? "mt-4" : "p-4 px-4")}>
        {children}
      </CollapsibleContent>
    </Collapsible>
  );
};
